var _path, _path2, _mask, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunWindRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7191 104.393C26.8862 104.122 31.3842 95 31.3842 95M76.5592 104.859C76.7263 104.588 81.2243 95.4655 81.2243 95.4655M51.6392 104.626C51.8063 104.355 56.3043 95.2328 56.3043 95.2328",
    stroke: "#51C2F0",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2823 38.5075C83.8685 54.679 73.6649 70.6974 57.4935 74.2823C41.3208 77.8685 25.3026 67.6649 21.7177 51.4921C18.1314 35.3206 28.3364 19.3036 44.5064 15.7173C60.6791 12.1324 76.6974 22.3347 80.2823 38.5075Z",
    fill: "#FFC318"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1",
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 41,
    width: 71,
    height: 50,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 31,
    y: 41,
    width: 71,
    height: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1201 86.9989C88.6713 86.8847 98 77.5269 98 66C98 54.402 88.556 45 76.9062 45C66.7013 45 58.1889 52.2145 56.2345 61.7999H47.6C40.6412 61.7999 35 67.4411 35 74.3999C35 81.3587 40.6412 86.9999 47.6 86.9999H76.8433C76.8643 87 76.8853 87 76.9062 87C76.9275 87 76.9487 87 76.9699 86.9999C77.02 86.9999 77.0701 86.9996 77.1201 86.9989Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1201 86.9989C88.6713 86.8847 98 77.5269 98 66C98 54.402 88.556 45 76.9062 45C66.7013 45 58.1889 52.2145 56.2345 61.7999H47.6C40.6412 61.7999 35 67.4411 35 74.3999C35 81.3587 40.6412 86.9999 47.6 86.9999H76.8433C76.8643 87 76.8853 87 76.9062 87C76.9275 87 76.9487 87 76.9699 86.9999C77.02 86.9999 77.0701 86.9996 77.1201 86.9989Z",
    fill: "#AAAAAA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1201 86.9989C88.6713 86.8847 98 77.5269 98 66C98 54.402 88.556 45 76.9062 45C66.7013 45 58.1889 52.2145 56.2345 61.7999H47.6C40.6412 61.7999 35 67.4411 35 74.3999C35 81.3587 40.6412 86.9999 47.6 86.9999H76.8433C76.8643 87 76.8853 87 76.9062 87C76.9275 87 76.9487 87 76.9699 86.9999C77.02 86.9999 77.0701 86.9996 77.1201 86.9989Z",
    stroke: "white",
    strokeWidth: 8,
    mask: "url(#path-4-outside-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunWindRain);
export default __webpack_public_path__ + "static/media/sun_wind_rain.941bc593086ca21a071f51c0cb1bf8a5.svg";
export { ForwardRef as ReactComponent };